// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1wv0Y","colMaxWidth":"Table_colMaxWidth__3HRSE"};